<template>
  <div class="dashboard p-4">
    <!-- end nav -->
     <div class="flex justify-between">
       <div class="">
         <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
           Detail Plant
         </h1>
       </div>
       <router-link to="/plants"
           class="inline-flex items-center border border-indigo-300 px-2 py-1 rounded-md text-indigo-500 hover:bg-indigo-50">
           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6">
               <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16l-4-4m0 0l4-4m-4 4h18">
               </path>
           </svg>
           <span class="ml-1 font-bold text-lg">Back</span>
       </router-link>
     </div>
    <div class="mt-2 w-full">
      <div
      class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
      </div>
    </div>
    <div
      class="wrapper-card grid grid-cols-1 gap-2 mt-5"
    >
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-2 border dark:border-gray-700 flex"
      >
        <div class="p-2 flex-auto">
          <h2 class=" text-gray-900 dark:text-gray-200">Varietas: {{ dataDetailPlant.varietas }}</h2>
          <h2 class=" text-gray-900 dark:text-gray-200 mt-1"> Taraf Cekaman: {{ dataDetailPlant.taraf }}%</h2>
          <h2 class=" text-gray-900 dark:text-gray-200 mt-1">Ulangan : {{ dataDetailPlant.ulangan }}</h2>
          <h2 class=" text-gray-900 dark:text-gray-200 mt-1">Status : {{ statusFunc }}</h2>
        </div>
        <div class="flex-auto">
          <h2 class=" text-gray-900 dark:text-gray-200 mt-1">Time : {{ dataDetailPlant.ulangan }}</h2>
          <h2 class=" text-gray-900 dark:text-gray-200 mt-1">Sensor : {{ dataDetailPlant.sensorIndex }}</h2>
          <h2 class=" text-gray-900 dark:text-gray-200 mt-1">Created Date : {{ formattedCreatedAt }}</h2>
        </div>
        <div>
          <router-link :to="'/plant/' + dataDetailPlant.id + '/config'" class="h-9">
              <div class="">
                <div style="height: 46px;width: 46px;" class="flex items-center justify-center hover:bg-orange-500 flex-1 h-full p-2 bg-yellow1 text-white shadow rounded-lg">
                  <div class="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                    </svg>
                  </div>
                </div>
              </div>
            </router-link>
            <div class="h-9 mt-2">
              <div class="cursor-pointer" v-on:click="deletePlantHandler">
                <div style="height: 46px;width: 46px;" class="flex items-center justify-center hover:bg-red-700 flex-1 h-full p-2 bg-red-500 text-white shadow rounded-lg">
                  <div class="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    
    <div class="mt-2 lg:flex block lg:gap-2 relative">
      <div class="sm:overflow-x-auto bg-white dark:bg-gray-800 p-0 lg:w-3/4 w-full rounded-md box-border border dark:border-gray-700 relative">
        <Chart :plantId="$route.params.id"/>
      </div>
      <div class="bg-white dark:bg-gray-800 p-5 lg:mt-0 lg:w-2/4 border dark:border-gray-700 rounded-md w-full">
        <radial-bar :sensor="dataDetailPlant.sensorIndex" :dataSen="dataSensor"/>
      </div>
    </div>
</div>


</template>

<script>
  import { useCounterStore } from "@/store/counter";
  import { Icon } from "@iconify/vue";
  import { mapActions, mapState } from "pinia";
  import radialBar from "./components/radialBar.vue";
  import { Vue3Lottie } from 'vue3-lottie';
  import Modal from '@/components/modal.vue';
  import Chart from "./Chart.vue";

  export default {
    name: "Dashboard",
    data() {
      return {
        dataSensor: 0,
        openModal: false,
      };
    },
    components: {
      Modal,Icon, radialBar, Vue3Lottie,Chart
    },
    methods: {
      ...mapActions(useCounterStore,['getDetailPLant','delPlant','getDataChart']),
      async deletePlantHandler(){
        const res = await this.delPlant(this.dataDetailPlant.id)
        if(res){
          this.$router.push('/plants')
        }
      },
      
    },
    created(){
      this.getDetailPLant(this.$route.params.id)
    },
    computed: {
      ...mapState(useCounterStore, [ 'seriesArea', 'optionsArea','dataDetailPlant', 'dataRealtime' ]),
      formattedCreatedAt() {
        if (this.dataDetailPlant && this.dataDetailPlant.createdAt) {
          const date = new Date(this.dataDetailPlant.createdAt);
          return date.toLocaleDateString("id-ID");
        }
        return "";
      },
      statusFunc(){
        if(this.dataRealtime?.[this.dataDetailPlant.sensorIndex]>(this.dataDetailPlant.taraf+5)){
          return 'High'
        }else if(this.dataRealtime?.[this.dataDetailPlant.sensorIndex]>(this.dataDetailPlant.taraf-5)){
          return 'Medium'
        }else {
          return 'Low'
        }
      }
    },
    mounted() {
    }
  };
</script>
